import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { alert_error, alert_success } from '../../../AppContext';
import { Cookies } from '../../../index.js';
const MyComponent = () => {
  const [listcauhinh, setListcauhinh] = useState(null);
  const [nickdangdung, setNickdangdung] = useState(null);
  const [chedokiemxu, setChedokiemxu] = useState(1);
  const [nutxuly, setNutxuly] = useState(null);
  const [idfacebook, setIdfacebook] = useState(null);
  const randomNumber = Math.floor(Math.random() * 100) + 1;
  const ok2 = Cookies.get('apikey');
  useEffect(() => {
    if (!ok2) {
      alert('Vui lòng đăng nhập');
    } else {
      checktk();
    }
  }, []);

  const dssdsdvsdvsdv = (info) => {
    console.log(randomNumber);
    if (info.status == 0) {
      alert_success(info.message);
      // this.$router.push('/cheofb');
    } else if (info.status == 3) {
      alert_success(info.message);
      // this.$router.push('/themcauhinh');
    } else if (info.status == 1) {
      alert_success(info.message);
      // this.$router.push('/cheofb');
    }
    setNutxuly(0);
  };

  const xacnhan = () => {
    setNutxuly(1);
    console.log(idfacebook);
    console.log(chedokiemxu);
    axios
      .post('https://hust.media/insta/profile.php', {
        key: ok2,
        idfacebook: idfacebook,
        chedo: 'choncauhinh',
        chedokiemxu: chedokiemxu
      })
      .then(response => {
        const info = response.data;
        console.log(info);
        dssdsdvsdvsdv(info);
        setNutxuly(0);
      })
      .catch(error => {
        console.log(error);
        setNutxuly(0);
      });
  };

  const asdasdkas = (info) => {
    if (info.status == 3) {
      alert_success('Vui lòng thêm tài khoản chéo Facebook');
      // this.$router.push('/themcauhinh');
    } else if (info.status == 0) {
      alert_error(info.message);
    } else if (info.status == 1) {
      alert_success(info.message);
      setListcauhinh(info.listcauhinh);
      setNickdangdung(info.nickdangdung);
      if (info.chedokiemxu) {
        setChedokiemxu(info.chedokiemxu);
      }
    }
  };

  const checktk = () => {
    axios
      .post('https://hust.media/insta/profile.php', {
        key: ok2,
        chedo: 'listcauhinh',
        social: 'tiktok'
      })
      .then(response => {
        const info = response.data;
        console.log(info);
        asdasdkas(info);
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <div className="row fixrow">
      <div className="text-center">
        <Link to="/themcauhinh">
          <button type="button" className="mx-2 btn-sm btn-primary">
            THÊM NICK FACEBOOK ĐỂ CHẠY
          </button>
        </Link>
        <Link to="/cheofb">
          <button type="button" className="mx-2 btn-sm btn-primary">
            Chéo Facebook
          </button>
        </Link>
      </div>
      <div className="max-w-2xl py-4 mx-auto rounded-lg shadow-xl">
        <div className="panel px-10 panel-primary">
          <div className="panel-heading">
            <h4 className="text-white">DANH SÁCH NICK FACEBOOK</h4>
          </div>
          <div className="panel-body">
            {listcauhinh == null ? (
              <div className="container-fluid">
                <div className="row" style={{ backgroundColor: '#FFB6C1' }}>
                  <p className="text-center" style={{ color: '#fff' }}>
                    <div className="text-center spinner-border" role="status"></div>
                    <br />
                    Đang tải danh sách
                  </p>
                </div>
              </div>
            ) : (
              <div className="container-fluid">
                {nickdangdung == null ? (
                  <div className="container-fluid">
                    <p className="text-center" style={{ color: '#fff' }}>
                      <br />
                      <h5> Chọn một tài khoản Facebook bên dưới để làm Jop</h5>
                    </p>
                  </div>
                ) : null}
                <div id="nickdangdung">
                  {nickdangdung !== null && (
                    <>
                      <label className="block font-bold">Nick đang dùng:</label>
                      <a href={nickdangdung.lienketfb} target="_blank" className="flex items-center">
                        <img src={nickdangdung.ava} className="w-10 h-10 rounded-full mr-2" alt="avatar" />
                        <span>{nickdangdung.tenfb}</span>
                      </a>
                      <div className="form-inline mt-2">
                        <label className="block font-bold mr-2">Chế độ kiếm Coins:</label>
                        <select
                          className="form-select"
                          value={chedokiemxu}
                          onChange={(e) => setChedokiemxu(e.target.value)}
                        >
                          <option value="1">Trình duyệt Facebook</option>
                          <option value="2">Ứng dụng Facebook</option>
                          {/* <option value="3">Trình duyệt điện thoại</option> */}
                        </select>
                      </div>
                    </>
                  )}
                  <ul id="dsnick" className="list-group mt-3 max-h-80 overflow-y-scroll">
                    {listcauhinh.map((user) => (
                      <li key={user.id} className="list-group-item">
                        <label className="radio-inline flex items-center">
                          <input
                            type="radio"
                            name="chk"
                            value={user.idfacebook}
                            className="form-radio form-radio-lg h-6 w-6 text-pink-500"
                            onChange={(e) => setIdfacebook(e.target.value)}
                          />
                          <a href={user.lienketfb} target="_blank" className="flex items-center">
                            <img src={user.ava} className="w-10 h-10 rounded-full ml-2 mr-2" alt="avatar" />
                            <span>{user.tenfb}</span>
                          </a>
                        </label>
                      </li>
                    ))}
                  </ul>
                  <br />
                  <div className="col" onClick={xacnhan}>
                    <div className="fixrow row text-center">
                      <div className="flex break-inside bg-white text-black border-2 border-black rounded-3xl px-6 py-1 w-auto dark:bg-slate-800 dark:text-white">
                        <div className="m-auto p-2">
                          <div className="flex items-center justify-start flex-1 space-x-4">
                            {nutxuly == '1' ? (
                              <div className="spinner-border" role="status"></div>
                            ) : (
                              <span className="font-medium px-2 text-sm">Đặt làm nick chạy</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyComponent;
